// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mMarginBottom4 {\n  margin-bottom: 4px;\n}\n\n.mMaxWidth80 {\n  max-width: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
